import axios from 'axios'
import router from "@/router";
import {useUserStore} from '@/stores/user'
import {ElMessage} from 'element-plus'
import debounce from "@/util/debounce";
import {aesEncrypt} from "@/util/aesEncrypt";

export const {decrypt} = aesEncrypt()

// 创建 Axios 实例（避免污染全局 Axios 配置）
const service = axios.create({
    baseURL: '/api',
    timeout: 30000, // 请求超时时间（10秒）
    // withCredentials: true // 跨域请求时携带 Cookie（需后端配合配置 CORS）
})

// ---------------------- 请求拦截器 ----------------------
service.interceptors.request.use(
    (config) => {
        const store = useUserStore()
        // 1. 统一添加 Token（用户登录后存储在本地，如 localStorage/sessionStorage/Pinia）
        const token = store.userToken || ''
        if (token) {
            config.headers.Token = `${token}` // JWT 格式示例
        }
        config.headers['content-Type'] = 'application/x-www-form-urlencoded'
        if (config.url === 'sys/file/upload') {
            config.headers['content-Type'] = 'multipart/form-data'
        }

        return config
    },
    (error) => {
        // 处理请求发送失败（如网络错误、请求参数格式错误）
        console.error('请求发送失败：', error.message)
        return Promise.reject(error) // 抛出错误，让调用方捕获
    }
)

function clearingData(data) {
    ElMessage({
        message: data.msg,
        type: 'error',
        placement: 'top',
    })
    const store = useUserStore()
    setTimeout(() => {
        //清空登录信息 跳转到登录页面
        store.logout()
        router.push({
            path: '/login',
            replace: false
        })
    }, 1300)
    return new Promise(() => {
    });
}

const excludeApi = ['sys/file/upload']

// ---------------------- 响应拦截器 ----------------------
service.interceptors.response.use(
    (response) => {
        const obj = response.data;
        const excludeApiStatus = excludeApi.some(item => response.config.url.includes(item))
        const codeArr = [200, 300, 400]
        if (codeArr.includes(obj.code) && obj.data && !excludeApiStatus) {
            response.data.data = JSON.parse(decrypt(obj.data))
        }
        if (obj.code === 164) {
            return debounce(clearingData(obj), 500)
        }
        return response.data
    },
    (error) => {
        // 统一处理响应错误（如 401 未授权、403 权限不足、500 服务器错误）
        console.error('响应错误：', error.response?.data || error.message)
        let data = error.response?.data || {}
        // console.log(error)
        // 1. 401：未授权（Token 过期/未登录），跳转登录页
        // if (error.response?.status === 401) {
        //     localStorage.removeItem('token') // 清除无效 Token
        //     window.location.href = '/login' // 跳转登录页（Vue Router 可使用 router.push）
        // }
        // 2. 403：权限不足，可提示用户或跳转无权限页面
        if (error.response?.status === 403) {
            ElMessage({
                message: '您暂无权限操作该功能',
                type: 'error',
                placement: 'top',
            })
            // ElMessage.error('您暂无权限操作该功能') // 需引入 Element Plus 等 UI 库
            // window.location.href = '/403'
        }

        // 3. 500：服务器错误，提示用户重试
        if (error.response?.status === 500) {
            ElMessage({
                message: '服务器内部错误，请稍后重试',
                type: 'error',
                placement: 'top',
            })
        }

        return Promise.reject(error) // 抛出错误，让调用方捕获
    }
)

export default service
